/**
 * If you are not familiar with React Navigation, refer to the "Fundamentals" guide:
 * https://reactnavigation.org/docs/getting-started
 *
 */
import {
  NavigationContainer,
  DefaultTheme,
  DarkTheme,
} from "@react-navigation/native";
import * as React from "react";
import { ColorSchemeName } from "react-native";

import AppContext from "../app-context/AppContext";

import LinkingConfiguration from "./LinkingConfiguration";
import RootNavigator from "./RootNavigator";
import ComponentsDemo from "./ComponentsDemo";

function Navigation({ colorScheme }: { colorScheme: ColorSchemeName }) {
  return (
    <NavigationContainer
      linking={LinkingConfiguration}
      // theme={colorScheme === "dark" ? DarkTheme : DefaultTheme}
      theme={DefaultTheme}
    >
      <AppContext.InstructorOrLearner>
        <RootNavigator />
      </AppContext.InstructorOrLearner>

      <AppContext.Admin>
        <ComponentsDemo />
      </AppContext.Admin>
    </NavigationContainer>
  );
}

export default Navigation;
